import QueryBuilder from 'ocus-shared-resources/src/ModelBinding/QueryBuilder';
import Model from 'ocus-shared-resources/src/ModelBinding/Model';

export default ({ app, $config }) => {
    QueryBuilder.setAxios(app.$axios);
    Model.setConfig($config)
}
